import React from "react";
import "./style.scss";

const MatchCreateIcon = () => {
  return (
    <svg id="match-create" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
      <path id="Rectangle_5527" data-name="Rectangle 5527" d="M0 0h32v32H0z" />
      <g id="gift_1_" data-name="gift (1)" transform="translate(.6 .2)">
        <path
          id="Subtraction_4"
          data-name="Subtraction 4"
          className="cls-2"
          d="M-3875.323-2552.97H-3892a1.979 1.979 0 0 1-1.929-1.929v-7.458h26.486v2.84a5.5 5.5 0 0 0-2.657-.684 5.507 5.507 0 0 0-5.5 5.5 5.5 5.5 0 0 0 .277 1.728zm8.781-11.315h-28.158a.88.88 0 0 1-.9-.9v-4.628a1.979 1.979 0 0 1 1.929-1.929h2.571a3.6 3.6 0 0 1-.771-2.314 5.149 5.149 0 0 1 5.143-5.144c2.527 0 4.074 1.4 6.043 3.986 1.97-2.585 3.518-3.986 6.043-3.986a5.149 5.149 0 0 1 5.144 5.144 4.438 4.438 0 0 1-.642 2.314h2.442a2 2 0 0 1 2.057 1.929v4.628a.88.88 0 0 1-.901.9zm-7.972-12.086c-1.172 0-2.094.312-5.015 4.628h5.015a2.334 2.334 0 0 0 1.591-.675 2.272 2.272 0 0 0 .723-1.639 2.3 2.3 0 0 0-.675-1.639 2.3 2.3 0 0 0-1.639-.675zm-12.215 0a2.3 2.3 0 0 0-1.639.675 2.3 2.3 0 0 0-.675 1.639 2.3 2.3 0 0 0 .675 1.639 2.3 2.3 0 0 0 1.639.675h5.144c-3.039-4.431-3.815-4.628-5.144-4.628z"
          transform="translate(3896 2581)"
        />
      </g>
      <path
        id="Path_15192"
        data-name="Path 15192"
        className="cls-2"
        d="M15 9v3h-3v2h3v3h2v-3h3v-2h-3V9z"
        transform="translate(11 14)"
      />
    </svg>
  );
};

export default MatchCreateIcon;
